import React, { useEffect, useMemo, useState } from 'react';
import ClinicInfo from './info/ClinicInfo';
import Hours from './hours/Hours';
import RecallHours from './recall/RecallHours';
import ClBrands from './ClBrands';
import SocialLinks from './SocialLinks';
import AppointmentNotes from './AppointmentNotes';
import WebBooking from './webbooking/WebBooking';
import ClinicSettingsNav from './subparts/ClinicSettingsNav';
import { useEyeconxStore } from '../../../../store/eyeconxStore';
import { isClinicFeatureEnabled } from '../../../../modules/clinicFeatures/clinicFeatureUtils';

const SETTINGS_TABS = [
    { id: 'general', label: 'General', icon: 'bi-building', theme: 'primary' },
    { id: 'hours', label: 'Hours', icon: 'bi-clock', theme: 'orange' },
    { id: 'recall-hours', label: 'Recall Settings', icon: 'bi-arrow-repeat', theme: 'purple' },
    {
        id: 'clbrands',
        label: 'Contact Lens Brands',
        icon: 'bi-eye',
        theme: 'cyan',
        featureKey: 'isOpticalDispensary',
    },
    { id: 'social-links', label: 'Social Links', icon: 'bi-share', theme: 'pink' },
    { id: 'appointment-notes', label: 'Appointment Notes', icon: 'bi-journal-text', theme: 'indigo' },
    { id: 'webbooking', label: 'Web Booking', icon: 'bi-globe2', theme: 'teal' },
];

function TabCard() {
    const clinicFeatures = useEyeconxStore((state) => state.clinicFeatures);
    const clinicFeaturesLoaded = useEyeconxStore((state) => state.clinicFeaturesLoaded);
    const [activeTab, setActiveTab] = useState('general');
    const [loadedTabs, setLoadedTabs] = useState(() => new Set(['general']));

    const visibleTabs = useMemo(
        () =>
            SETTINGS_TABS.filter((tab) =>
                isClinicFeatureEnabled(tab.featureKey, clinicFeatures, clinicFeaturesLoaded)
            ),
        [clinicFeatures, clinicFeaturesLoaded]
    );

    useEffect(() => {
        if (!visibleTabs.some((tab) => tab.id === activeTab)) {
            setActiveTab('general');
        }
    }, [visibleTabs, activeTab]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setLoadedTabs((prev) => new Set([...prev, tabId]));
    };

    const tabContent = useMemo(
        () => ({
            general: <ClinicInfo />,
            hours: <Hours />,
            'recall-hours': <RecallHours />,
            clbrands: <ClBrands />,
            'social-links': <SocialLinks />,
            'appointment-notes': <AppointmentNotes />,
            webbooking: <WebBooking />,
        }),
        []
    );

    return (
        <div className="row g-3 clinic-settings-layout">
            <div className="col-12 col-lg-3 col-xl-3">
                <ClinicSettingsNav
                    tabs={visibleTabs}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                />
            </div>

            <div className="col-12 col-lg-9 col-xl-9">
                <div className="ecx-page-card ecx-page-panel clinic-settings-panel">
                    <div className="ecx-page-panel__body ecx-page-scroll">
                        {visibleTabs.map((tab) =>
                            loadedTabs.has(tab.id) ? (
                                <div
                                    key={tab.id}
                                    className={activeTab === tab.id ? '' : 'd-none'}
                                >
                                    {tabContent[tab.id]}
                                </div>
                            ) : null
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TabCard;
